import { BlogShared } from './../../general/shared/blog-shared';
import { TribuneAnalyticsService } from './../../../data/repository/analytics-repository/tribune-analytics.service';
import { BlogService } from 'src/app/data/repository/blog-repository/blog.service';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { SnackBarService } from 'src/app/data/repository/utils-repository/snack-bar.service';
import { TextHelper } from 'src/app/utils/text-helper';

@Component({
  selector: 'app-set-username-bottomsheet',
  templateUrl: './set-username-bottomsheet.component.html',
  styleUrls: ['./set-username-bottomsheet.component.scss'],
})
export class SetUsernameBottomsheetComponent implements OnInit {
  SWIPE_ACTION = { UP: 'swipeup', DOWN: 'swipedown' };

  isButtonActive = false;
  username = '';
  showLoading = false;
  hasError = false;
  message = '';

  constructor(
    private bottomSheetRef: MatBottomSheetRef<SetUsernameBottomsheetComponent>,
    private textHelper: TextHelper,
    private blogService: BlogService,
    private snackBarService: SnackBarService,
    private cdRef: ChangeDetectorRef,
    private tribuneAnalytics: TribuneAnalyticsService,
    private blogShared: BlogShared
  ) {}

  ngOnInit() {}

  swipe(action: string = this.SWIPE_ACTION.DOWN) {
    if (action === this.SWIPE_ACTION.DOWN) {
      this.bottomSheetRef.dismiss();
    }
  }

  checkAvailability() {
    this.isButtonActive = false;
    if (this.username !== '') {
      const checkAnswer = this.textHelper.checkUsername(this.username);
      if (checkAnswer === 'correct') {
        this.showLoading = true;
        this.cdRef.detectChanges();
        this.blogService.validateUsername(this.username).then((res) => {
          console.log({ res });

          if (res.isSuccess()) {
            this.message = '';
            this.hasError = false;
            this.isButtonActive = true;
          } else {
            if (res.getData().getMessage()) {
              this.message = res.getData().getMessage();
              this.hasError = true;
              this.isButtonActive = false;
            } else {
              this.snackBarService.showSnackBar(
                'خطا در برقراری ارتباط با سرور!'
              );
            }
          }
          this.showLoading = false;
          this.cdRef.detectChanges();
        });
      } else {
        this.message = checkAnswer;
        this.hasError = true;
        this.isButtonActive = false;
      }
    } else {
      this.hasError = false;
      this.message = '';
      this.isButtonActive = false;
    }
  }

  submit() {
    if (this.isButtonActive) {
      this.showLoading = true;
      this.cdRef.detectChanges();
      this.blogService
        .editBlogUser(null, this.username, null, null, null)
        .then((result) => {
          if (result.isSuccess()) {
            this.tribuneAnalytics.analyticTribuneUsernameSet();
            this.snackBarService.showSnackBar(
              'نام کاربری با موفقیت تغییر یافت.'
            );
            this.bottomSheetRef.dismiss();
            this.blogShared.usernameChange(this.username);
          } else {
            this.message = result.getData().getMessage();
            this.hasError = true;
            this.isButtonActive = false;
          }
          this.showLoading = false;
          this.cdRef.detectChanges();
        });
    }
  }

  clearUsername() {
    this.username = '';
  }

  animateButton() {
    const button = document.getElementById('set-button');
    button.style.width = '56px';
    button.style.right = 'calc( 50% - 28px )';
    setTimeout(() => {
      this.showLoading = true;
      this.cdRef.detectChanges();
    }, 200);
  }
}
